import {
  put,
  takeLatest,
  all,
  call,
  takeLeading,
  select
  // takeEvery
} from 'redux-saga/effects';
import {
  LOGIN,
  SIGN_UP,
  CHANGE_PASSWORD,
  loginSuccess,
  logoutSuccess,
  UPDATE_SCREEN_NAME,
  SOCIAL_LOGIN,
  GET_USER_PROFILE_DETAILS,
  EDIT_USER_PROFILE,
  updateUserInfo,
  LOGOUT,
  GET_USER_PASSWORD,
  GET_ADDRESSES,
  updateUserPassword,
  ADD_ADDRESS,
  DELETE_ADDRESS,
  UPDATE_ADDRESS,
  TOGGLE_DEFAULT_ADDRESS,
  TOGGLE_DEFAULT_PHONE,
  TOGGLE_DEFAULT_BANK,
  TOGGLE_DEFAULT_EMAIL,
  DELETE_EMAIL,
  DELETE_PHONE,
  DELETE_BANK,
  DELETE_PAN,
  USER_PLAYING_HISTORY,
  GET_PAN_DETAILS,
  GET_BANK_DETAILS,
  GET_PHONE_DETAILS,
  GET_EMAIL_DETAILS,
  updateEmail,
  updateBank,
  updatePhone,
  updateAddressInfo,
  updatePan,
  SEND_MOBILE_OTP,
  VERIFY_MOBILE_OTP,
  SEND_EMAIL_OTP,
  VERIFY_EMAIL_OTP,
  PHONE_LOGIN,
  PHONE_REGISTER,
  RESET_PASSWORD_SEND_EMAIL,
  RESET_PASSWORD_VERIFY_EMAIL,
  ADD_EMAIL,
  GENERATE_REFERRAL_LINK,
  UPDATE_USER_NAME,
  GET_REVENUE_ANALYTICS_REFERRAL,
  GET_REVENUE_ANALYTICS_AFFILIATE,
  GET_USER_ANALYTICS_AFFILIATE,
  GET_USER_ANALYTICS_REFERRAL,
  GET_FEEDBACK_FORM,
  POST_FEEDBACK_FORM
} from '../actions/user-actions-types';
import httpClient from './http-client';
import I18n from '../utilities/locale';
import { showErrorToast, showToast } from '../actions/app-actions-types';
// import Connection from '../utilities/Connection';

export function* login({ payload: { data, callback } }) {
  const email = data.email;
  const password = data.password;
  const from = data.from;
  const payload = {
    auth: {
      username: email,
      password: password
    },
    method: 'POST',
    url: 'auth/login/basic',
    type: 'login'
  };
  const { result, error } = yield call(httpClient, payload);
  callback({
    result,
    error
  });
  if (!error) {
    const userId = result.id;
    const token = result.token;
    const loginType = 'email';
    yield put(
      loginSuccess({
        userId,
        loginType,
        name: '',
        token
      })
    );
    if (from === undefined) {
      yield put(showToast(I18n.t('LoginSuccessMsg')));
    }
  }
}

export function* phoneLogin({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'auth/login/phone',
    type: 'login'
  };
  const { result, error } = yield call(httpClient, payload);
  if (!error) {
    const userId = result.id;
    const token = result.token;
    const loginType = 'mobile';
    yield put(
      loginSuccess({
        userId,
        loginType,
        token
      })
    );
    yield put(showToast(I18n.t('LoginSuccessMsg')));
  }
  callback({
    result,
    error
  });
}

export function* phoneRegister({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'auth/register/phone',
    type: 'phoneRegister'
  };
  const { result, error } = yield call(httpClient, payload);
  if (!error) {
    callback({
      result,
      error
    });
  }
}

function* signUp({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'auth/register/basic'
  };
  const { result, error } = yield call(httpClient, payload);

  if (!error) {
    callback({
      result,
      error
    });
  } else {
    yield put(
      showErrorToast(I18n.t(error.details !== undefined ? error.details[0].message : error.message))
    );
  }
}

function* logout() {
  const { loginType } = yield select((state) => state.user);
  if (loginType === 'google') {
    yield call(signOutGoogle);
  }
  yield put(logoutSuccess());
}

function* signOutGoogle() {
  // try {
  //   yield call(GoogleSignin.signOut)
  // } catch (error) {
  //   console.error(error)
  // }
}

function* changePassword({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('loginid', data.userId);
  formData.append('oldpassword', data.currentPassword);
  formData.append('newpassword', data.password);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/changepassword'
  };

  const { result, error } = yield call(httpClient, payload);

  if (!error) {
    if (result.status) {
      callback({
        result,
        error
      });
      if (result.status === 1) {
        yield put(updateUserPassword(data.password));
      }
      // yield put(ToastActionsCreators.displayInfo(result.message))
    } else {
      // yield put(ToastActionsCreators.displayError(result.message))
    }
  }
}

function* updateScreenName({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('user_id', data.userId);
  formData.append('teamname', data.screenName);
  formData.append('dob', data.dob);
  formData.append('state', '');
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/leauges/updateteamname'
  };

  const { result, error } = yield call(httpClient, payload);

  if (!error) {
    if (result[0].status) {
      if (result[0].status === 'already exist') {
        // yield put(
        //   ToastActionsCreators.displayError(I18n.t('AlreadyTakenScreenName'))
        // )
      } else {
        callback({
          result,
          error
        });
        // yield put(ToastActionsCreators.displayInfo(result[0].status))
      }
    } else {
      // yield put(ToastActionsCreators.displayError(result[0].msg))
    }
  }
}

function* socialLogin({ payload: { data, callback } }) {
  const formData = new FormData();
  const email = data.email;
  const name = data.name;
  const image = data.image;
  formData.append('email', email);
  formData.append('name', name);
  formData.append('provider', data.provider);
  formData.append('image', image);
  formData.append('dob', data.dob);
  formData.append('appid', data.appid);
  formData.append('code', data.code);
  // formData.append('device_id', data.device_id)
  formData.append('affiliate_code', data.affiliate_code);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'sociallogin'
  };

  const { result, error } = yield call(httpClient, payload);

  if (!error) {
    if (result[0].status) {
      const userId = result[0].uid;
      const loginType = data.provider;
      yield put(
        loginSuccess({
          userId,
          loginType,
          photo: image
        })
      );
      callback({
        result,
        error
      });
      // yield put(ToastActionsCreators.displayInfo(result[0].msg))
    } else {
      // yield put(ToastActionsCreators.displayError(result[0].msg))
    }
  }
}

function* getUserProfileDetails({ payload: { callback } }) {
  try {
    const payload = {
      //data: {},
      method: 'GET',
      url: 'users'
    };
    const { result, error } = yield call(httpClient, payload, false);
    callback({
      result,
      error
    });
    if (!error) {
      if (result) {
        yield put(updateUserInfo(result));
      }
    }
  } catch (error) {
    //
  }
}

function* editUserProfile({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'PATCH',
    url: 'users'
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* getUserPassword({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('userid', data.userId);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/password_google'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({
    result,
    error
  });
  if (!error) {
    if (result[0].status === '1') {
      const { password } = result[0];
      yield put(updateUserPassword(password));
    }
  }
}

function* getAddresses({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'addresses'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({
    result,
    error
  });
  if (!error) {
    if (result) {
      yield put(updateAddressInfo(result));
    }
  }
}

function* addAddress({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'addresses'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* toggleDefaultAddress({ payload: { data, callback } }) {
  const payload = {
    method: 'PATCH',
    url: `addresses/${data.addressId}`
  };
  const { result, error } = yield call(httpClient, payload);
  callback({
    result,
    error
  });
}

function* deleteAddress({ payload: { data, callback } }) {
  const payload = {
    method: 'DELETE',
    url: `addresses?where={"id":"${data.deleteId}"}`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* updateAddress({ payload: { data, callback } }) {
  const { id } = data;
  const body = {
    street: data.street,
    city: data.city,
    state: data.state,
    zip: data.zip
  };
  const payload = {
    method: 'PATCH',
    data: body,
    url: `addresses/${id}`
  };

  const { result, error } = yield call(httpClient, payload, true);

  callback({
    result,
    error
  });
}

function* toggleDefaultEmail({ payload: { data, callback } }) {
  const payload = {
    method: 'PATCH',
    url: `emails/${data.id}/default`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* toggleDefaultPhone({ payload: { data, callback } }) {
  const payload = {
    method: 'PATCH',
    url: `phones/${data.id}/default`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* toggleDefaultBank({ payload: { data, callback } }) {
  const payload = {
    method: 'PATCH',
    url: `bank-accounts/${data.id}/default`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* deleteEmail({ payload: { data, callback } }) {
  const payload = {
    method: 'DELETE',
    url: `emails?where={"id":"${data.id}"}`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* deletePhone({ payload: { data, callback } }) {
  const payload = {
    method: 'DELETE',
    url: `phones?where={"id":"${data.id}"}`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* deleteBank({ payload: { data, callback } }) {
  const payload = {
    method: 'DELETE',
    url: `bank-accounts/${data.id}`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
}

function* deletePan({ payload: { data, callback } }) {
  const payload = {
    method: 'DELETE',
    url: `pan?where={"id":"${data.id}"}`
  };

  const { result, error } = yield call(httpClient, payload);

  callback({
    result,
    error
  });
  if (!error) {
    yield put(updatePan({}));
  }
}

function* getUserPlayingHistory({ payload: { data, callback } }) {
  const { userId = '' } = data;
  const payload = {
    method: 'GET',
    url: `fantasy-cricket/contests/summary/users/${userId}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* getPAN_Details({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'pan'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({
    result,
    error
  });
  if (!error) {
    if (result) {
      yield put(updatePan(result));
    } else if (result === null) {
      yield put(updatePan({}));
    }
  } else if (error.statusCode === 404) {
    yield put(updatePan({}));
  }
}

function* getBankDetails({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'bank-accounts'
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });

  if (!error) {
    if (result) {
      yield put(updateBank(result));
    }
  }
}

function* getPhoneDetails({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'phones'
  };

  const { result, error } = yield call(httpClient, payload, false);

  if (!error) {
    if (result) {
      yield put(updatePhone(result));
    }
  }

  callback({
    result,
    error
  });
}

function* getEmailDetails({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'emails'
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });

  if (!error) {
    if (result) {
      yield put(updateEmail(result));
    }
  }
}

function* sendMobileOTP({ payload: { data, callback } }) {
  // if (Connection.getAppId() != 'iGamio-dev') {
  //   delete data.resendOTP;
  // }
  const payload = {
    data: data,
    method: 'POST',
    url: 'verifications/phone',
    type: 'sendMobileOTP'
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* verifyMobileOTP({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'PATCH',
    url: 'verifications/phone',
    type: 'login'
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* sendEmailOTP({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'verifications/email'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* verifyEmailOTP({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'PATCH',
    url: 'verifications/email'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* resetPasswordSendEmail({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'auth/password-reset'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* resetPasswordVerifyEmail({ payload: { data, callback } }) {
  const payload = {
    data,
    method: 'PATCH',
    url: 'auth/password-reset'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* addEmail({ payload: { data, callback } }) {
  const body = {
    email: data.email
    // provider: 'google',
    // providerId: 'string'
  };
  const payload = {
    data: body,
    type: 'addEmail',
    method: 'POST',
    url: 'emails'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* generateReferralLink({ payload: { callback } }) {
  const payload = {
    method: 'POST',
    url: 'referrals'
  };

  const { result, error } = yield call(httpClient, payload, true);
  callback({
    result,
    error
  });
}

function* getRevenueAnalyticsReferral({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `game-analytics/referrals/${data.referralId}?timeline={
      "startDate":"${data.startDate}", 
      "endDate":"${data.endDate}"
      }`
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* getRevenueAnalyticsAffiliate({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `game-analytics/affiliates/${data.affiliateId}?timeline={
      "startDate":"${data.startDate}", 
      "endDate":"${data.endDate}"
      }`
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* getUserAnalyticsReferral({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `referrals/${data.referralId}/user-analytics?timeline={
      "startDate":"${data.startDate}", 
      "endDate":"${data.endDate}"
      }`
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* getUserAnalyticsAffiliate({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `affiliates/${data.affiliateId}/user-analytics?timeline={
      "startDate":"${data.startDate}", 
      "endDate":"${data.endDate}"
      }`
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* updateUserName({ payload: { data, callback } }) {
  const body = {
    username: data.userName
  };
  const payload = {
    data: body,
    method: 'PATCH',
    url: 'users/username'
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* getFeedbackForm({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: `feedback-forms/response`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* postFeedbackForm({ payload: { data, callback } }) {
  const { id, responseData } = data;
  const payload = {
    method: 'POST',
    url: `feedback-forms/response/${id}/save`,
    data: responseData
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({
    result,
    error
  });
}

function* User() {
  yield all([
    takeLeading(LOGIN, login),
    takeLeading(SIGN_UP, signUp),
    takeLeading(LOGOUT, logout),
    takeLeading(CHANGE_PASSWORD, changePassword),
    takeLeading(UPDATE_SCREEN_NAME, updateScreenName),
    takeLeading(SOCIAL_LOGIN, socialLogin),
    takeLatest(GET_USER_PROFILE_DETAILS, getUserProfileDetails),
    takeLeading(EDIT_USER_PROFILE, editUserProfile),
    takeLatest(GET_USER_PASSWORD, getUserPassword),
    takeLatest(GET_ADDRESSES, getAddresses),
    takeLeading(ADD_ADDRESS, addAddress),
    takeLeading(DELETE_ADDRESS, deleteAddress),
    takeLeading(UPDATE_ADDRESS, updateAddress),
    takeLeading(TOGGLE_DEFAULT_ADDRESS, toggleDefaultAddress),
    takeLeading(TOGGLE_DEFAULT_PHONE, toggleDefaultPhone),
    takeLeading(TOGGLE_DEFAULT_EMAIL, toggleDefaultEmail),
    takeLeading(TOGGLE_DEFAULT_BANK, toggleDefaultBank),
    takeLeading(DELETE_EMAIL, deleteEmail),
    takeLeading(DELETE_PHONE, deletePhone),
    takeLeading(DELETE_BANK, deleteBank),
    takeLeading(DELETE_PAN, deletePan),
    takeLatest(USER_PLAYING_HISTORY, getUserPlayingHistory),
    takeLatest(GET_PHONE_DETAILS, getPhoneDetails),
    takeLatest(GET_EMAIL_DETAILS, getEmailDetails),
    takeLatest(GET_BANK_DETAILS, getBankDetails),
    takeLatest(GET_PAN_DETAILS, getPAN_Details),
    takeLeading(SEND_MOBILE_OTP, sendMobileOTP),
    takeLeading(VERIFY_MOBILE_OTP, verifyMobileOTP),
    takeLeading(SEND_EMAIL_OTP, sendEmailOTP),
    takeLeading(VERIFY_EMAIL_OTP, verifyEmailOTP),
    takeLeading(PHONE_LOGIN, phoneLogin),
    takeLeading(PHONE_REGISTER, phoneRegister),
    takeLeading(RESET_PASSWORD_SEND_EMAIL, resetPasswordSendEmail),
    takeLeading(RESET_PASSWORD_VERIFY_EMAIL, resetPasswordVerifyEmail),
    takeLeading(ADD_EMAIL, addEmail),
    takeLeading(GENERATE_REFERRAL_LINK, generateReferralLink),
    takeLeading(UPDATE_USER_NAME, updateUserName),
    takeLatest(GET_REVENUE_ANALYTICS_REFERRAL, getRevenueAnalyticsReferral),
    takeLatest(GET_REVENUE_ANALYTICS_AFFILIATE, getRevenueAnalyticsAffiliate),
    takeLatest(GET_USER_ANALYTICS_REFERRAL, getUserAnalyticsReferral),
    takeLatest(GET_USER_ANALYTICS_AFFILIATE, getUserAnalyticsAffiliate),
    takeLatest(GET_FEEDBACK_FORM, getFeedbackForm),
    takeLatest(POST_FEEDBACK_FORM, postFeedbackForm)
  ]);
}

export default User;
